module.exports = __webpack_public_path__ + "media/images/main_slider/Tabungan WOW Premium-d3a5b481aa3db1a341810ad22167d5a5.png";